<template>
  <v-dialog ref="weekModelDialog" v-model="weekModal" height="90vh" width="700px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout column align-center>
        <v-card width="100%" ref="form">
          <v-card-title>
            <v-col cols="12">
              <v-row justify="center">
                <div align="center" class="primary--text">
                  <h1 v-if="!saveMode">{{ $t("newWeeklyModel") }}</h1>
                  <h1 v-else>{{ $t("editWeeklyModel") }}</h1>
                </div>
              </v-row>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-layout class="ma-0 pa-0" justify-space-between row>
              <v-flex grow>
                <v-text-field
                  v-model="WeekModel.weekModelName"
                  :disabled="WeekModel.locked"
                  @change="calculateWeekTime"
                  :counter="50"
                  :label="$t('weeklyModelName')"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex class="ml-3" shrink>
                <v-text-field
                  v-model="WeekModel.weeklyTime"
                  :disabled="WeekModel.locked"
                  :label="$t('weeklyWorkTime')"
                  prepend-icon="mdi-clock-outline"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout class="ma-0 pa-0" justify-space-between column>
              <v-flex>
                <v-select
                  v-model="WeekModel.MondayId"
                  :disabled="WeekModel.locked"
                  :items="weekDailyModelList"
                  :label="$t('monday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('MondayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.TuesdayId"
                  :disabled="WeekModel.locked"
                  :items="weekDailyModelList"
                  :label="$t('tuesday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('TuesdayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.WednesdayId"
                  :disabled="WeekModel.locked"
                  :items="weekDailyModelList"
                  :label="$t('wednesday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('WednesdayId')"
                  @change="calculateWeekTime"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.ThursdayId"
                  :disabled="WeekModel.locked"
                  :items="weekDailyModelList"
                  :label="$t('thursday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('ThursdayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.FridayId"
                  :items="weekDailyModelList"
                  :disabled="WeekModel.locked"
                  :label="$t('friday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('FridayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.SaturdayId"
                  :items="weekDailyModelList"
                  :disabled="WeekModel.locked"
                  :label="$t('saturday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('SaturdayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-select
                  v-model="WeekModel.SundayId"
                  :items="weekDailyModelList"
                  :disabled="WeekModel.locked"
                  :label="$t('sunday')"
                  :append-icon="'mdi-close'"
                  :rules="selecterRules"
                  chips
                  @click:append="clickHandler('SundayId')"
                  @change="calculateWeekTime"
                  >{{ weekDailyModelList.dailyModelName }}</v-select
                >
              </v-flex>
              <v-flex>
                <v-checkbox v-model="WeekModel.emptyOnMonthStart" :disabled="WeekModel.locked" :label="$t('emptyTimeAccountOnMonthStart')"></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox v-model="WeekModel.deductBreakTimes" :disabled="WeekModel.locked" :label="$t('deductBreakTimes')"></v-checkbox>
                <v-row no-gutters v-for="(item, i) in deductBreaks" :key="i">
                  <v-text-field
                    v-if="WeekModel.deductBreakTimes"
                    v-model="item.deductFrom"
                    :rules="[rules.time.regex]"
                    :label="$t('deductTimeFrom')"
                    :disabled="WeekModel.locked"
                    append-icon="mdi-close"
                    @click:append="item.deductFrom = ''"
                    class="pr-2"
                  ></v-text-field>
                  <v-text-field
                    v-if="WeekModel.deductBreakTimes"
                    v-model="item.deductBreak"
                    :rules="[rules.time.regex]"
                    :label="$t('break')"
                    :disabled="WeekModel.locked"
                    append-icon="mdi-close"
                    @click:append="item.deductBreak = ''"
                    class="pl-2"
                  ></v-text-field
                ></v-row>
              </v-flex>
              <v-flex>
                <v-row no-gutters>
                  <v-checkbox v-model="WeekModel.cutStartTime" :disabled="WeekModel.locked" class="pr-4" :label="$t('cutStartTime')"></v-checkbox>
                  <v-checkbox v-model="WeekModel.cutEndTime" :disabled="WeekModel.locked" :label="$t('cutEndTime')"></v-checkbox>
                </v-row>
              </v-flex>
            </v-layout>

            <v-textarea
              name="input-7-1"
              :disabled="WeekModel.locked"
              :label="$t('remark')"
              :counter="254"
              class="pb-2"
              :rules="remarkRules"
              v-model="WeekModel.weekModelText"
            ></v-textarea>

            <v-layout align-center justify-center>
              <v-btn v-if="!saveMode" color="primary" class="buttonHoverOpacity" @click="addWeekModel">{{ $t("addWeeklyModel") }}</v-btn>
              <v-btn v-else color="primary" class="buttonHoverOpacity" @click="saveWeekModel">{{ $t("saveWeeklyModel") }}</v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "WeeklyDialog",

  data: (vm) => ({
    weekModal: true,
    valid: true,
    saveMode: false,
    isWeekModelValid: false,
    WeekModel: {
      id: 0,
      weeklyTime: "00:00",
      weekModelName: "",
      MondayId: "",
      TuesdayId: "",
      WednesdayId: "",
      ThursdayId: "",
      FridayId: "",
      SaturdayId: "",
      SundayId: "",
      weekModelText: "",
      emptyOnMonthStart: false,
      deductBreaks: []
    },
    deductBreaks: [
      { deductFrom: "06:00", deductBreak: "00:30" },
      { deductFrom: "09:00", deductBreak: "00:15" },
      {
        deductFrom: "",
        deductBreak: ""
      },
      {
        deductFrom: "",
        deductBreak: ""
      },
      {
        deductFrom: "",
        deductBreak: ""
      }
    ],
    rules: {
      time: {
        required: (v) => !v || v.length <= 5 || 'Falsches Format ("HH:mm")',
        regex: (v) => !v || /^(([0-9]?[0-9])*|2[0-9]):[0-5][0-9]$/.test(v) || vm.$t("enterCorrectStartTimeFormat")
      }
    },

    loaderOverlay: false,

    nameRules: [],

    selecterRules: [],
    remarkRules: [(v) => v.length <= 254 || vm.$t("maximumCharacterLengthReached")]
  }),
  props: {
    weekDailyModelList: Array,
    dailyModelList: Array,
    weekModelId: Number
  },
  created: function () {
    if (this.weekModelId != 0) {
      this.getWeekModel(this.weekModelId);
    }
    this.selecterRules = [(v) => !!v || this.$t("dailyModelNotSelected")];
    this.nameRules = [(v) => !!v || this.$t("nameIsRequired"), (v) => v.length <= 50 || this.$t("maximumCharacterLengthReached")];
  },
  beforeDestroy: function () {
    this.$emit("close");
  },
  watch: {
    weekModal: function (val) {
      if (!val) {
        this.$destroy();
      }
    }
  },
  methods: {
    async getWeekModel(weekModelId) {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("server/timeAccounts/getWeekModel", weekModelId)
        .then((resp) => {
          this.processWeekModel(resp.data.data, weekModelId);
        })
        .catch((err) => {
          console.log(err);
          this.$eventHub.$emit("showError", err);
        });
      this.loaderOverlay = false;
    },
    clickHandler(item) {
      this.WeekModel[item] = "";
      this.calculateWeekTime(null);
    },
    calculateWeekTime(e) {
      if (this.WeekModel.weekModelName != undefined && this.WeekModel.weekModelName != "") {
        this.isWeekModelValid = true;
      } else {
        this.isWeekModelValid = false;
      }

      var summe = 0;

      let currentModel;

      if (this.WeekModel.MondayId != undefined) {
        var val = this.WeekModel.MondayId.value != undefined ? this.WeekModel.MondayId.value : this.WeekModel.MondayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.TuesdayId != undefined) {
        var val = this.WeekModel.TuesdayId.value != undefined ? this.WeekModel.TuesdayId.value : this.WeekModel.TuesdayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.WednesdayId != undefined) {
        var val = this.WeekModel.WednesdayId.value != undefined ? this.WeekModel.WednesdayId.value : this.WeekModel.WednesdayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.ThursdayId != undefined) {
        var val = this.WeekModel.ThursdayId.value != undefined ? this.WeekModel.ThursdayId.value : this.WeekModel.ThursdayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.FridayId != undefined) {
        var val = this.WeekModel.FridayId.value != undefined ? this.WeekModel.FridayId.value : this.WeekModel.FridayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.SaturdayId != undefined) {
        var val = this.WeekModel.SaturdayId.value != undefined ? this.WeekModel.SaturdayId.value : this.WeekModel.SaturdayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (this.WeekModel.SundayId != undefined) {
        var val = this.WeekModel.SundayId.value != undefined ? this.WeekModel.SundayId.value : this.WeekModel.SundayId;
        currentModel = this.dailyModelList.find((model) => model.id == val);
        if (currentModel != undefined) summe = summe + currentModel.duration;
      }

      if (
        this.WeekModel.MondayId == undefined ||
        this.WeekModel.MondayId == "" ||
        this.WeekModel.TuesdayId == undefined ||
        this.WeekModel.TuesdayId == "" ||
        this.WeekModel.WednesdayId == undefined ||
        this.WeekModel.WednesdayId == "" ||
        this.WeekModel.ThursdayId == undefined ||
        this.WeekModel.ThursdayId == "" ||
        this.WeekModel.FridayId == undefined ||
        this.WeekModel.FridayId == "" ||
        this.WeekModel.SaturdayId == undefined ||
        this.WeekModel.SaturdayId == "" ||
        this.WeekModel.SundayId == undefined ||
        this.WeekModel.SundayId == ""
      )
        this.isWeekModelValid = false;

      var summenText = Helper.convMinit2Time(summe);
      this.WeekModel.weeklyTime = summenText;
    },
    async addWeekModel() {
      if (this.$refs.form.validate()) {
        this.loaderOverlay = true;
        var sendWeekModel = this.WeekModel;
        sendWeekModel.weeklyTime = Helper.convTime2Minit(this.WeekModel.weeklyTime);
        sendWeekModel.MondayId =
          this.WeekModel.MondayId != undefined ? (this.WeekModel.MondayId.value == undefined ? this.WeekModel.MondayId : this.WeekModel.MondayId.value) : 0;
        sendWeekModel.TuesdayId =
          this.WeekModel.TuesdayId != undefined ? (this.WeekModel.TuesdayId.value == undefined ? this.WeekModel.TuesdayId : this.WeekModel.TuesdayId.value) : 0;
        sendWeekModel.WednesdayId =
          this.WeekModel.WednesdayId != undefined
            ? this.WeekModel.WednesdayId.value == undefined
              ? this.WeekModel.WednesdayId
              : this.WeekModel.WednesdayId.value
            : 0;
        sendWeekModel.ThursdayId =
          this.WeekModel.ThursdayId != undefined
            ? this.WeekModel.ThursdayId.value == undefined
              ? this.WeekModel.ThursdayId
              : this.WeekModel.ThursdayId.value
            : 0;
        sendWeekModel.FridayId =
          this.WeekModel.FridayId != undefined ? (this.WeekModel.FridayId.value == undefined ? this.WeekModel.FridayId : this.WeekModel.FridayId.value) : 0;
        sendWeekModel.SaturdayId =
          this.WeekModel.SaturdayId != undefined
            ? this.WeekModel.SaturdayId.value == undefined
              ? this.WeekModel.SaturdayId
              : this.WeekModel.SaturdayId.value
            : 0;
        sendWeekModel.SundayId =
          this.WeekModel.SundayId != undefined ? (this.WeekModel.SundayId.value == undefined ? this.WeekModel.SundayId : this.WeekModel.SundayId.value) : 0;

        sendWeekModel.emptyOnMonthStart = this.WeekModel.emptyOnMonthStart ? 1 : 0;
        sendWeekModel.U_cutStartTime = this.WeekModel.cutStartTime ? 1 : 0;
        sendWeekModel.U_cutEndTime = this.WeekModel.cutEndTime ? 1 : 0;
        sendWeekModel.deductBreakTimes = this.WeekModel.deductBreakTimes ? 1 : 0;
        sendWeekModel.deductBreaks = this.deductBreaks;

        await this.$store
          .dispatch("server/timeAccounts/addWeeklyModel", sendWeekModel)
          .then((resp) => {
            this.weekModal = false;
            this.$eventHub.$emit("showSuccess", this.$t("dataSendSuccessfully"));
          })
          .catch((err) => {
            console.log(err);
            this.$eventHub.$emit("showError", err);
          });
        this.loaderOverlay = false;
      }
    },
    async saveWeekModel() {
      if (this.$refs.form.validate()) {
        this.loaderOverlay = true;
        if (this.WeekModel.weekModelName == undefined || this.WeekModel.weekModelName == "") {
          this.$eventHub.$emit("showError", this.$t("weekModelWithoutNameNotAllowed"));
          this.isWeekModelValid = false;
          return;
        } else {
          this.isWeekModelValid = true;
        }
        let sendWeekModel = {};
        sendWeekModel.U_text = this.WeekModel.weekModelText;
        sendWeekModel.Name = this.WeekModel.weekModelName;
        sendWeekModel.U_monday =
          this.WeekModel.MondayId != undefined ? (this.WeekModel.MondayId.value == undefined ? this.WeekModel.MondayId : this.WeekModel.MondayId.value) : 0;
        sendWeekModel.U_tuesday =
          this.WeekModel.TuesdayId != undefined ? (this.WeekModel.TuesdayId.value == undefined ? this.WeekModel.TuesdayId : this.WeekModel.TuesdayId.value) : 0;
        sendWeekModel.U_wednesday =
          this.WeekModel.WednesdayId != undefined
            ? this.WeekModel.WednesdayId.value == undefined
              ? this.WeekModel.WednesdayId
              : this.WeekModel.WednesdayId.value
            : 0;
        sendWeekModel.U_thursday =
          this.WeekModel.ThursdayId != undefined
            ? this.WeekModel.ThursdayId.value == undefined
              ? this.WeekModel.ThursdayId
              : this.WeekModel.ThursdayId.value
            : 0;
        sendWeekModel.U_friday =
          this.WeekModel.FridayId != undefined ? (this.WeekModel.FridayId.value == undefined ? this.WeekModel.FridayId : this.WeekModel.FridayId.value) : 0;
        sendWeekModel.U_saturday =
          this.WeekModel.SaturdayId != undefined
            ? this.WeekModel.SaturdayId.value == undefined
              ? this.WeekModel.SaturdayId
              : this.WeekModel.SaturdayId.value
            : 0;
        sendWeekModel.U_sunday =
          this.WeekModel.SundayId != undefined ? (this.WeekModel.SundayId.value == undefined ? this.WeekModel.SundayId : this.WeekModel.SundayId.value) : 0;

        sendWeekModel.U_emptyTimeBalanceAfterMonthEnd = this.WeekModel.emptyOnMonthStart ? 1 : 0;
        sendWeekModel.U_cutStartTime = this.WeekModel.cutStartTime ? 1 : 0;
        sendWeekModel.U_cutEndTime = this.WeekModel.cutEndTime ? 1 : 0;
        sendWeekModel.U_deductBreakTimes = this.WeekModel.deductBreakTimes ? 1 : 0;
        sendWeekModel.U_deductFrom1 = this.timeToMinutes(this.deductBreaks[0].deductFrom);
        sendWeekModel.U_deductBreak1 = this.timeToMinutes(this.deductBreaks[0].deductBreak);
        sendWeekModel.U_deductFrom2 = this.timeToMinutes(this.deductBreaks[1].deductFrom);
        sendWeekModel.U_deductBreak2 = this.timeToMinutes(this.deductBreaks[1].deductBreak);
        sendWeekModel.U_deductFrom3 = this.timeToMinutes(this.deductBreaks[2].deductFrom);
        sendWeekModel.U_deductBreak3 = this.timeToMinutes(this.deductBreaks[2].deductBreak);
        sendWeekModel.U_deductFrom4 = this.timeToMinutes(this.deductBreaks[3].deductFrom);
        sendWeekModel.U_deductBreak4 = this.timeToMinutes(this.deductBreaks[3].deductBreak);
        sendWeekModel.U_deductFrom5 = this.timeToMinutes(this.deductBreaks[4].deductFrom);
        sendWeekModel.U_deductBreak5 = this.timeToMinutes(this.deductBreaks[4].deductBreak);

        let sendObject = {
          id: this.WeekModel.id,
          sendWeekModel
        };

        await this.$store
          .dispatch("server/timeAccounts/saveWeeklyModel", sendObject)
          .then((resp) => {
            this.weekModal = false;

            if (resp.data.success) this.$eventHub.$emit("showSuccess", this.$t("dataSendSuccessfully"));
            else this.$eventHub.$emit("showError", this.$t(resp.data.error));
          })
          .catch((err) => {
            console.log(err);
            this.$eventHub.$emit("showError", err);
          });
        this.loaderOverlay = false;
      }
    },
    processWeekModel(model, id) {
      this.saveMode = true;
      this.WeekModel.weekModelName = model.weekModelName;
      this.WeekModel.weekModelText = model.weekModelText;
      this.WeekModel.id = id;
      this.WeekModel.emptyOnMonthStart = model.emptyOnMonthStart;
      this.WeekModel.MondayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.MondayId) != undefined ? this.dailyModelList.find((x) => x.id == model.MondayId).dailyModelName : "",
        value: this.dailyModelList.find((x) => x.id == model.MondayId) != undefined ? this.dailyModelList.find((x) => x.id == model.MondayId).id : ""
      };
      this.WeekModel.TuesdayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.TuesdayId) != undefined ? this.dailyModelList.find((x) => x.id == model.TuesdayId).dailyModelName : "",
        value: this.dailyModelList.find((x) => x.id == model.TuesdayId) != undefined ? this.dailyModelList.find((x) => x.id == model.TuesdayId).id : ""
      };
      this.WeekModel.WednesdayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.WednesdayId) != undefined
            ? this.dailyModelList.find((x) => x.id == model.WednesdayId).dailyModelName
            : "",
        value: this.dailyModelList.find((x) => x.id == model.WednesdayId) != undefined ? this.dailyModelList.find((x) => x.id == model.WednesdayId).id : ""
      };
      this.WeekModel.ThursdayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.ThursdayId) != undefined
            ? this.dailyModelList.find((x) => x.id == model.ThursdayId).dailyModelName
            : "",
        value: this.dailyModelList.find((x) => x.id == model.ThursdayId) != undefined ? this.dailyModelList.find((x) => x.id == model.ThursdayId).id : ""
      };
      this.WeekModel.FridayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.FridayId) != undefined ? this.dailyModelList.find((x) => x.id == model.FridayId).dailyModelName : "",
        value: this.dailyModelList.find((x) => x.id == model.FridayId) != undefined ? this.dailyModelList.find((x) => x.id == model.FridayId).id : ""
      };
      this.WeekModel.SaturdayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.SaturdayId) != undefined
            ? this.dailyModelList.find((x) => x.id == model.SaturdayId).dailyModelName
            : "",
        value: this.dailyModelList.find((x) => x.id == model.SaturdayId) != undefined ? this.dailyModelList.find((x) => x.id == model.SaturdayId).id : ""
      };
      this.WeekModel.SundayId = {
        text:
          this.dailyModelList.find((x) => x.id == model.SundayId) != undefined ? this.dailyModelList.find((x) => x.id == model.SundayId).dailyModelName : "",
        value: this.dailyModelList.find((x) => x.id == model.SundayId) != undefined ? this.dailyModelList.find((x) => x.id == model.SundayId).id : ""
      };
      this.WeekModel.locked = model.locked;
      this.WeekModel.cutStartTime = model.cutStartTime;
      this.WeekModel.cutEndTime = model.cutEndTime;
      this.WeekModel.deductBreakTimes = model.deductBreakTimes;
      this.deductBreaks = model.deductBreaks;

      this.calculateWeekTime();
    },

    timeToMinutes(time) {
      if (time == "" || time == undefined) return "";
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    }
  }
};
</script>

<style></style>
